import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewAutomationModal from 'modules/automations/components/NewAutomationModal'

const NewAutomationModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.automations.fullPath())
  }

  const onSuccess = (id: number) => {
    navigate(navigation.settings.automations.id.fullPath({ id }))
  }

  return <NewAutomationModal onClose={onClose} onSuccess={onSuccess} />
}

export default NewAutomationModalPage
